import { nextArrow, prevArrow, options } from "@/global/slick-options";

jQuery( '.big-slider-slider' ).slick( {
    ...options,
    dots: false,
    infinite: false,
    slidesToShow: 1.25,
    slidesToScroll: 1,
    arrows: true,
    rows: 0,
    prevArrow,
    nextArrow,
    responsive: [
        {
            breakpoint: 980,
            settings: {
                slidesToShow: 1,
            }
        },
    ]
} );
